// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PED_VEN_ST = {
  EmAndamento: 'PED_VEN_ST1',
  Concluido: 'PED_VEN_ST2',
  Cancelado: 'PED_VEN_ST3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PED_VEN_ST1: 1,
    PED_VEN_ST2: 2,
    PED_VEN_ST3: 3
  }
}
